import type { RoomCircuitName } from "./types";

// Three names still read as a place; past that the card would be a list.
const NAMED_ROOMS = 3;

export const roomCircuitName: RoomCircuitName = ({ roomNames }) => {
  const named = roomNames.slice(0, NAMED_ROOMS).join(", ");
  const more = roomNames.length - NAMED_ROOMS;
  return more > 0 ? `${named} +${more}` : named;
};
